import { createFileRoute } from "@tanstack/react-router";
import Kontakt from "@/pages/Kontakt";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/kontakt")({
  head: () =>
    buildSeoHead(publicPageSeo.kontakt, [
      buildPageSchema(publicPageSeo.kontakt, "ContactPage"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/kontakt") ?? []),
    ]),
  component: Kontakt,
});
